import React from 'react';


interface IToggleOptionTitleProps {
  children?: string;
}

export default function ToggleOptionTitle({ children }: IToggleOptionTitleProps) {
  return (
    <span className="ag-toggle-option__title">{children}</span>
  );
}
